module.exports = __webpack_public_path__ + "img/occupation-area.6c86f8fb.svg";